import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'pay_charge_project',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '充值产品',
        addFunName: 'payChargeProjectAdd',
        modifyFunName: 'payChargeProjectModify',
        delFunName: 'payChargeProjectDel',
        queryFunName: 'payChargeProjectQuery',
        detailFunName: 'payChargeProjectDetail',
        onlineFunName: 'payChargeProjectOnline',
        unOnlineFunName: 'payChargeProjectUnOnline'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        onlineState: null,
        sortField: 'sort'
      },
      formData: {
        givingCost: null,
        priceCost: null,
        name: null,
        listImage: null,
        backgroundImage: null,
        onlineState: true,
        sort: null,
        discountCost: null
      },
      rules: {
        name: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }],
        onlineState: [{
          required: true,
          message: '请选择上架状态',
          trigger: 'blur'
        }],
        priceCost: [{
          required: true,
          message: '请输入产品价格',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '价格必须为有效金额',
          trigger: 'blur'
        }],
        discountCost: [{
          required: true,
          message: '请输入折扣价格',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '折扣价格必须为有效金额',
          trigger: 'blur'
        }],
        givingCost: [{
          required: true,
          message: '请输入赠送价格',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '赠送价格必须为有效金额',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    online: function online(id) {
      var _this = this;
      this.$api[this.pageConfig.onlineFunName](id).then(function (res) {
        if (res.data) {
          _this.$message.success('上架成功');
          _this.query();
        } else {
          _this.$message.error('上架失败');
        }
      });
    },
    unOnline: function unOnline(id) {
      var _this2 = this;
      this.$api[this.pageConfig.unOnlineFunName](id).then(function (res) {
        if (res.data) {
          _this2.$message.success('下架成功');
          _this2.query();
        } else {
          _this2.$message.error('下架失败');
        }
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));

      // 处理产品价格
      if (paramData.priceCost) {
        paramData.priceCost = (paramData.priceCost / 100).toFixed(2);
      }

      // 处理折扣价格
      if (paramData.discountCost) {
        paramData.discountCost = (paramData.discountCost / 100).toFixed(2);
      }

      // 处理赠送费用
      if (paramData.givingCost) {
        paramData.givingCost = (paramData.givingCost / 100).toFixed(2);
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));

      // 处理产品价格
      if (saveFormData.priceCost) {
        saveFormData.priceCost = (saveFormData.priceCost * 100).toFixed(0);
      }

      // 处理折扣价格
      if (saveFormData.discountCost) {
        saveFormData.discountCost = (saveFormData.discountCost * 100).toFixed(0);
      }

      // 处理赠送费用
      if (saveFormData.givingCost) {
        saveFormData.givingCost = (saveFormData.givingCost * 100).toFixed(0);
      }
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadback: function uploadback(_ref) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this3.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this3.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this3.formData.backgroundImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    uploadhead: function uploadhead(_ref3) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              _this4.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this4.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this4.formData.listImage = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    previewFile: function previewFile(key) {
      window.open(this.formData[key]);
    },
    removeFile: function removeFile(key) {
      this.formData[key] = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this5 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this5.initFormData(res.data);
        _this5.editDialogTitle = _this5.pageConfig.editPageName + '维护';
        _this5.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this6 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this6.$api[_this6.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this6.$message.success('删除成功');
            _this6.query();
          } else {
            _this6.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this7 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this7.tableData = res.data || [];
        _this7.totalCount = res.count;
        _this7.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this8 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this8.formData.id) {
            _this8.$api[_this8.pageConfig.modifyFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
              if (res.data) {
                _this8.$message.success('编辑成功');
                _this8.initFormData(_this8.emptyFormData);
                _this8.editDialogShow = false;
                _this8.query();
              } else {
                _this8.$message.error('编辑失败');
              }
            });
          } else {
            _this8.$api[_this8.pageConfig.addFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
              if (res.data) {
                _this8.$message.success('新增成功');
                _this8.initFormData(_this8.emptyFormData);
                _this8.editDialogShow = false;
                _this8.query();
              } else {
                _this8.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};